import React from 'react';
import { Layout } from '@economic/react-app';

export const NotFound = () => {
    return (
        <Layout>
            <Layout.Content>
                <div className="p-8 h-full flex flex-col items-center justify-center space-y-4">
                    <img
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGIAAABeCAMAAADvwzHqAAABFFBMVEX///8iIiIjIyMkJCQlJSUqKiorKyssLCwuLi4vLy8wMDAyMjI5OTk7Ozs9PT1BQUFCQkJGRkZHR0dMTExOTk5QUFBSUlJTU1NUVFRVVVVWVlZXV1dYWFhZWVldXV1gYGBhYWFiYmJjY2NkZGRmZmZoaGhqampsbGxtbW1ubm5vb29zc3N2dnZ5eXmEhISFhYWGhoaIiIiJiYmLi4uMjIyNjY2YmJiampqbm5ucnJydnZ2enp6goKChoaGnp6esrKyvr6+0tLS4uLi7u7u8vLzExMTMzMzOzs7Pz8/S0tLc3Nze3t7h4eHi4uLl5eXm5ubq6urr6+vt7e3v7+/w8PDx8fHy8vL09PT19fX7+/v+/v7////BjGZ4AAAAAXRSTlMAQObYZgAAAbBJREFUeNrt2dlOwkAUgOEZQRFxAauyWVkFUVGK1YIIKLtoBali5bz/e2i8IDFF4MgMMTj/VdNz8aXL9GJKTC0U8HLLF8oZRFNegWN9tUBCJnDNjBIvcC5AdnkTPkFgid7Bst3GLkf4yULspwxgmJFKWYiVPuM157AQNmCcXRCCEIQgFoIY6PoALFnGMxANN6XuBgAgxjhCd9DPHDoAYowjFPqVAoAY44gk/SoJgBjzuQr+z4L/G8V/XYgPiCAEIYi/QDy3qqWCphVK1dYze8KoZPweOa0Wy7e35aKalj3+TMVgR3TzQUmp9uBbvaoiBfNdJkQ9JmkdGFlHk2L1mYnaTqIJY2omdmozEYNIvA0TasejgxkIMGCKDLH0BLGoxBJ/ws56y2vVQiQYb9wdH1kISNmonV1rJ7rYChYEu+5crjvOhJNS5zwI/jdKvFFYQuL/001+4yuYYXKTfeEp9C+vCClKW3u+SW2MOTe2SJ5MmQzWZDJVghDE/Iiz+N6w9eHRqHPekPorYftahyl7f8yeEnwXKmA6z+GJzQcUcX+IJyigMmU8EQBcgX9LIPuZ+ACynmoZOPGX0QAAAABJRU5ErkJggg=="
                        alt="Page not found"
                    />
                    <h1>Page not found</h1>
                    <p>Unfortunately we couldn't find the page you're looking for</p>
                </div>
            </Layout.Content>
        </Layout>
    );
};
